import { createImg } from "../../../DomUtilities/ElementsCreator";
import Item from "../../../Models/Item";
import Service from "../../../Models/Service";
import Variant from "../../../Models/Variant";
import { ServiceType } from "../../../Models/ServiceType";
import OrderHandler from "../OrderHandler";
import Mediator from "../../../Utilities/Mediator";

export function createItemServiceVariantTiles() {
	const variantsWrapper: HTMLDivElement = document.querySelector('.create-order + div');
	variantsWrapper.innerHTML = "";
	variantsWrapper.appendChild(createImg("/assets/shopping_cart2.svg", "cart icon"));
	OrderHandler.order.items.forEach(item => {
		item.services.forEach(service => {
			service.variants.forEach(variant => {
				variantsWrapper.appendChild(createVariantTile(item, service, variant));
			});
		});
	});
}

function createVariantTile(item: Item, service: Service, variant: Variant): HTMLDivElement {
	const tileDiv = document.createElement('div');
	const itemNameDiv = document.createElement('div');
	const serviceNameDiv = document.createElement('div');
	const variantDiv = document.createElement('div');
	const priceDiv = document.createElement('div');
	const closeImg = createImg('/assets/close_B.svg', 'close icon');
	const p = document.createElement('p');

	tileDiv.id = `item${item.itemId}${service.id}`;
	tileDiv.dataset.itemId = item.itemId;
	itemNameDiv.classList.add('modal__head');
	serviceNameDiv.innerText = serviceNameDiv.title = service.name;
	variantDiv.innerText = variantDiv.title = getVariantDetails(service.type, variant);
	priceDiv.innerText = `${variant.cost} Kr.`;
	p.innerText = item.name;
	p.title = item.name;

	itemNameDiv.appendChild(p);
	itemNameDiv.appendChild(closeImg);
	tileDiv.appendChild(itemNameDiv);
	tileDiv.appendChild(serviceNameDiv);
	tileDiv.appendChild(variantDiv);
	tileDiv.appendChild(priceDiv);

	addCloseImgClickListener(closeImg, tileDiv, service);

	return tileDiv;
}

function addCloseImgClickListener(closeImg: HTMLImageElement, tileDiv: HTMLDivElement, service: Service) {
	closeImg.onclick = () => {
		tileDiv.remove();

		if (service.itemId === OrderHandler.selectedItem.itemId) {
			Mediator.emit("serviceCostChanged", service.id, -1);
			service.variants.forEach(v => Mediator.emit("variantRemoved", v.id));
		}

		OrderHandler.removeVariants(service.itemId, service.id);
	}
}

function getVariantDetails(serviceType: ServiceType, variant: Variant): string {
	switch (serviceType) {
		case ServiceType.Canvas:
			return `${variant.name}, kanvas `;
		case ServiceType.Measurements:
			if (variant.byNeedle) {
				return `${variant.name}, nål `;
			} else {
				let cm;
				if (variant.cmDown) {
					cm = `+${variant.cmDown}`;
				} else {
					cm = `-${variant.cmUp}`;
				}
				return `${variant.name}, ${cm} cm `;
			}
		default:
			return `${variant.name} `;
	}
}
